const playPauseVideo = () => {
    const videos = document.querySelectorAll('.tile-video');
    videos.forEach((video) => {
        // We can only control playback without insteraction if video is mute
        // eslint-disable-next-line no-param-reassign
        video.muted = true;
        // Play is a promise so we need to check we have it
        const playPromise = video.play();
        if (playPromise !== undefined) {
            // eslint-disable-next-line no-unused-vars
            playPromise.then((_) => {
                const observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (entry.intersectionRatio !== 1 && !video.paused) {
                                video.pause();
                            } else if (video.paused) {
                                video.play();
                            }
                        });
                    },
                    { threshold: 0.2 },
                );
                observer.observe(video);
            }).catch((e) => {
                console.log(e);
            });
        }
    });
};

module.exports = {
    playPauseVideo,
};
